var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 32,
    cy: 32,
    r: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDPR-Personopplysning-forside",
    transform: "translate(-595.000000, -568.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(595.000000, 568.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spotlight/-gjenstand-"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("g", {
    id: "spotlight/-element",
    mask: "url(#mask-2)",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-60"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NAV-Brand/farge/-Bl\\xE5/-60",
    mask: "url(#mask-4)",
    fill: "#99C2E8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "bl\\xE5-60",
    points: "0 64 64 64 64 0 0 0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(12.800000, 19.200000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6,0 L0.8,0 C0.3584,0 0,0.3584 0,0.8 L0,26.4 C0,26.8416 0.3584,27.2 0.8,27.2 L7.2,27.2 C7.6416,27.2 8,26.8416 8,26.4 L8,25.2 C8,24.0976 8.8976,23.2 10,23.2 C11.1024,23.2 12,24.0976 12,25.2 L12,26.4 C12,26.8416 12.3584,27.2 12.8,27.2 L25.6,27.2 C26.0416,27.2 26.4,26.8416 26.4,26.4 L26.4,25.2 C26.4,24.0976 27.2976,23.2 28.4,23.2 C29.5024,23.2 30.4,24.0976 30.4,25.2 L30.4,26.4 C30.4,26.8416 30.7584,27.2 31.2,27.2 L37.6,27.2 C38.0416,27.2 38.4,26.8416 38.4,26.4 L38.4,0.8 C38.4,0.3584 38.0416,0 37.6,0 Z",
    id: "line/id-card-1",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5690A2",
    cx: 9.63529412,
    cy: 8,
    rx: 3.23529412,
    ry: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1411765,19.2 C16.1411765,15.6653776 13.2441954,12.8 9.67058824,12.8 C6.09698103,12.8 3.2,15.6653776 3.2,19.2 C3.2,19.2 15.7098039,19.2 16.1411765,19.2 Z",
    id: "Oval",
    fill: "#5690A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8545455,17.6 L32.9454545,17.6 C33.30695,17.6 33.6,17.9581722 33.6,18.4 C33.6,18.8418278 33.30695,19.2 32.9454545,19.2 L19.8545455,19.2 C19.49305,19.2 19.2,18.8418278 19.2,18.4 C19.2,17.9581722 19.49305,17.6 19.8545455,17.6 Z",
    id: "Rectangle",
    fill: "#3E3832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8545455,14.4 L32.9454545,14.4 C33.30695,14.4 33.6,14.7581722 33.6,15.2 C33.6,15.6418278 33.30695,16 32.9454545,16 L19.8545455,16 C19.49305,16 19.2,15.6418278 19.2,15.2 C19.2,14.7581722 19.49305,14.4 19.8545455,14.4 Z",
    id: "Rectangle",
    fill: "#3E3832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8545455,11.2 L32.9454545,11.2 C33.30695,11.2 33.6,11.5581722 33.6,12 C33.6,12.4418278 33.30695,12.8 32.9454545,12.8 L19.8545455,12.8 C19.49305,12.8 19.2,12.4418278 19.2,12 C19.2,11.5581722 19.49305,11.2 19.8545455,11.2 Z",
    id: "Rectangle",
    fill: "#3E3832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.84,6.4 L24.96,6.4 C25.3134622,6.4 25.6,6.7581722 25.6,7.2 C25.6,7.6418278 25.3134622,8 24.96,8 L19.84,8 C19.4865378,8 19.2,7.6418278 19.2,7.2 C19.2,6.7581722 19.4865378,6.4 19.84,6.4 Z",
    id: "Rectangle",
    fill: "#3E3832"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalia);
export default __webpack_public_path__ + "static/media/Personalia.2902728ec1a806aebcf9e407be84ea1c.svg";
export { ForwardRef as ReactComponent };